import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganization } from "@/hooks/use-organization";

export interface Client {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  status: string;
  client_type: "in_person" | "virtual";
  current_package_size: number;
  upcoming_session_number: number;
  previous_session_number: number;
  avatar_url?: string | null;
}

export function useClients() {
  const { organization } = useOrganization();

  return useQuery({
    queryKey: ["clients", organization?.id],
    queryFn: async () => {
      if (!organization?.id) return [];

      const { data, error } = await supabase
        .from("clients")
        .select("id, name, email, phone, status, client_type, current_package_size, upcoming_session_number, previous_session_number, avatar_url")
        .eq("organization_id", organization.id)
        .order("name");

      if (error) {
        console.error("Error fetching clients:", error);
        throw error;
      }

      return (data || []) as Client[];
    },
    enabled: !!organization?.id,
    staleTime: 30000, // 30 seconds cache
  });
}

export default useClients;
